import { FirebaseOptions } from '@firebase/app';

// peech-dev's Firebase: the dev web service verifies ID tokens against it, so a signed-in
// request only works with a token from here. Values: peech-infra's web_app_firebase_config.

export const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyBeP9W5tfMvBh2-1P050UGnvuyGaT3T4JQ',
  authDomain: 'peech-dev.firebaseapp.com',
  projectId: 'peech-dev',
  storageBucket: 'peech-dev-user-files',
};

export const PEECH_FIRESTORE_DATABASE_ID = 'dev-peech-items';
